/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/heading-has-content */

import React, { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import Store from "~/common/Store";
import { Product } from "~/common/Store/models/ProductListing";
import InactiveEventCarouselMember from "./CarouselMember";

interface Props {
  products: Product[];
}

const startCarousel = async (element: HTMLUListElement) => {
  const { default: FixedWidthCarousel } = await import(
    "~/common/FixedWidthCarousel"
  );
  new FixedWidthCarousel({ selector: element });
};

const Carousel = ({ products }: Props) => {
  const carouselContainer = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (carouselContainer.current) {
      startCarousel(carouselContainer.current);
    }
  });

  function getCarouselMembers() {
    if (products.length > 0) {
      return products.map((product) => {
        return (
          <InactiveEventCarouselMember
            product={product}
            key={product.itemNumber}
          />
        );
      });
    }

    return [];
  }

  const carouselTitle = (
    <h3 className="clears">
      Featured Sales
      <a href="/specials.html" className="title-link">
        Shop All Sales <i className="icon-breadcrumb" />
      </a>
    </h3>
  );

  return (
    <Provider store={Store}>
      {carouselTitle}
      <div className="carousel-wrap">
        <div
          id="-carousel"
          className="carousel-wrap"
          data-component="-carousel"
        >
          <h3 className="clears" />

          <div
            id="other-products"
            className="basic-carousel other-products other-products--vertical carousel-box"
            data-component="carousel"
          >
            <div className="ag-carousel-nav">
              <a
                className="other-products--radius ag-car-prev"
                data-control="prev"
              />
              <a className="ag-car-next" data-control="next" />
            </div>
            <div
              id="otherProductsCarousel"
              className="ag-carousel-frame other-products--radius box"
            >
              <ul ref={carouselContainer} className="ag-carousel ag-full">
                {getCarouselMembers()}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <br />
    </Provider>
  );
};

export default Carousel;
